<script>

  import WaitingFor from './WaitingFor.svelte';
  import Button from './Button.svelte';
  import Modal from './Modal.svelte';
  import GoogleRegistrationForm from './GoogleRegistrationForm.svelte';
  
  import { waitlistForm } from '../stores.js';

  export let user;
  export let style = 'background-color: var(--primary); color: var(--background); font-size: larger;';
  export let selectedUse;
  export let short = false;

  let modalVisible = false;
  let email;
  let contact = false;
  let submitted = false;
  let submitting = false;
  let submitCallback;
  let form;
  let use;
  let invalid = true

  const submit = async () => {
    submitting = true;
    try {
      await submitCallback[1].get('telekinesis-inc/join_waitlist')()(email, use, contact)._timeout(10);
      // modalVisible = false;
      submitted = true;
    } catch (e) {
      submitCallback = [false, GoogleRegistrationForm]
    }
  }

  waitlistForm.subscribe(w => {
    if (w?.email != email || w?.use != use || w?.contact != contact || w?.submitCallback != submitCallback || submitted != w?.submitted) {
      email = w?.email;
      use = w?.use;
      contact = w?.contact;
      submitted = w?.submitted;
      submitCallback = w?.submitCallback;
    }
  })

  $: {
    waitlistForm.update(() => {return {email, use, contact, submitCallback, submitted}})
  }
  
  const load = async () => {
    modalVisible = true;
    use = selectedUse;
    if (submitCallback == undefined) {
      try {
        submitCallback = [true, await user._timeout(1)];//.get('telekinesis-inc/join_waitlist')()._timeout(1);
      } catch(e) {
        submitCallback = [false, GoogleRegistrationForm]
      }
    } 
  }

</script>

<div class='container'>
  <Button style={style} on:click={load}>Get{short ? '' : ' Early Access'}</Button>
</div>

<Modal bind:visible={modalVisible}>

  {#if submitted}
    <h1>Get Early Access</h1>
    <p>Thank you, we'll contact you soon</p>
    
    <Button on:click={() => {modalVisible = false}}>Close</Button>

  {:else}
    {#if submitCallback}
      {#if submitCallback[0]}
        <h1>Get Early Access</h1>
        {#if submitting}
          <WaitingFor message='Submitting' />
        {:else}
          <form class="pure-form pure-form-stacked" bind:this={form} on:submit|preventDefault={submit}>
            <fieldset>
              <legend class='legend'>Email</legend>
              <input type="email" class='pure-input email' id="email" bind:value={email} required 
                on:input={() => setTimeout(() => {invalid = !form.checkValidity()}, 80)}/>
            </fieldset>
            <fieldset>
              <legend class='legend'>Would you have a 30 min chat with telekinesis.cloud founder?</legend>
              <div style="margin: 0 auto; max-width: 600px;">
                <label for="contact" class='pure-checkbox'>
                  <input type="checkbox" id="contact" name='contact' bind:checked={contact}/>
                  Yes, prioritize my use-cases!
                </label>
              </div>
            </fieldset>
          </form>
          <div>
            <Button on:click={() => {modalVisible = false}}>Close</Button>
            <Button 
              style="background-color: var(--primary); color: var(--background);" 
              disabled={invalid}
              on:click={submit}>Submit</Button>
          </div>
        {/if}
      {:else}
        <svelte:component this={submitCallback[1]} />
        <Button on:click={() => {modalVisible = false}}>Close</Button>
      {/if}
    {:else}
      <h1>Get Early Access</h1>
      <WaitingFor />
      
      <Button on:click={() => {modalVisible = false}} >Close</Button>
    {/if}
  {/if}
</Modal>

<style>
  #email {
    text-align: center;
    margin: 0 auto;
    border-radius: 5px;
    width: 100%;
    max-width: 600px;
    box-shadow: none;
  }
  .legend {
    color: var(--tertiary);
    border-bottom: none;
    font-weight: 500;
  }
  @media (min-width: 800px) {
    fieldset {
      margin: 30px;
    }
  }
  .container {
    background-color: var(--background);
  }
</style>